<div class="config-fields">
  @for (field of fields(); track field.id) {
    @if (field.kind === 'array') {
      <fieldset class="config-group config-array">
        @if (field.label) {
          <legend>{{ field.label }}</legend>
        }
        @for (item of field.children; track item.id) {
          <div class="array-item">
            <app-config-json-fields [fields]="item.children" (fieldChange)="onChild($event)" (listChange)="onList($event)"></app-config-json-fields>
            <app-secondary-button title="Remove" icon="pi pi-trash" size="small" (action)="removeItem(item)"></app-secondary-button>
          </div>
        }
        <app-secondary-button title="Add" icon="pi pi-plus" size="small" (action)="addItem(field)"></app-secondary-button>
      </fieldset>
    } @else if (field.kind === 'group') {
      <fieldset class="config-group">
        @if (field.label) {
          <legend>{{ field.label }}</legend>
        }
        <app-config-json-fields [fields]="field.children" (fieldChange)="onChild($event)" (listChange)="onList($event)"></app-config-json-fields>
      </fieldset>
    } @else if (field.kind === 'boolean') {
      <app-checkbox
        [label]="field.label"
        [ngModel]="field.value === true"
        (ngModelChange)="onBoolean(field, $event)"
      ></app-checkbox>
    } @else if (field.kind === 'number') {
      <msf-input
        [label]="field.label"
        type="number"
        [min]="-1000000000"
        [model]="field.value"
        (modelChange)="onText(field, $event)"
      ></msf-input>
    } @else if (field.kind === 'secret') {
      <msf-input
        [label]="field.label"
        type="password"
        [model]="field.value"
        (modelChange)="onText(field, $event)"
      ></msf-input>
    } @else {
      <msf-input
        [label]="field.label"
        [model]="field.value"
        (modelChange)="onText(field, $event)"
      ></msf-input>
    }
  }
</div>
